import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const getClientList = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/list_clients`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getEngagementList = async (client_name) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/list_batches`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { client_name },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowList = async (client_name, batch_name) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/list_jobs`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { client_name, batch_name },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getDataSetList = async (client_name, batch_name, job_name) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/list_dataset`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { client_name, batch_name, job_name },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getFileByLanguageList = async (language) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/${language}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getPdfFileList = async (client_name, batch_name, job_name, language) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`http://40.76.226.63:3000/list_pdf_files`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { client_name, batch_name, job_name, language },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
